<template>
  <div>
    <sidebar :show="sidebar.opened && !sidebar.hidden" :role="role" :userId="userId"></sidebar>

    <section class="app-main">
      <div class="container is-fluid is-marginless app-content">
        <levelbar></levelbar>
        <transition
          mode="out-in"
          enter-active-class="fadeIn"
          leave-active-class="fadeOut"
          appear>
          <router-view class="animated"></router-view>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import { Sidebar, Levelbar, FooterBar } from '../components/layout'
import { mapGetters, mapActions } from 'vuex'
import UserProfile from '../services/userservice'

export default {
  components: {
    Sidebar,
    Levelbar,
    FooterBar
  },

  data: function () {
    return {
      role: 0,
      userId: null
    }
  },

  beforeMount () {
    const { body } = document
    const WIDTH = 768
    const RATIO = 3

    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let isMobile = rect.width - RATIO < WIDTH
        this.toggleDevice(isMobile ? 'mobile' : 'other')
        this.toggleSidebar(!isMobile)
      }
    }

    var user = UserProfile.getUserProfile()
    this.role = user.role
    this.userId = user.id

    handler()
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },

  computed: mapGetters({
    sidebar: 'sidebar'
  }),

  methods: mapActions([
      'toggleDevice',
      'toggleSidebar'
    ])
}
</script>

<style lang="scss">
@import '~animate.css';
.animated {
  animation-duration: .377s;
}

@import '~bulma';

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

@import '~bulma/sass/utilities/variables';
@import '~bulma/sass/utilities/mixins';

.app-main {
  padding-top: 50px;
  margin-left: 200px;
  transform: translate3d(0, 0, 0);

  @include mobile() {
    margin-left: 0;
  }

}

.app-content {
  padding: 20px;
}
.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;

  #nprogress {
    $color: #48e79a;

    .bar {
      background: $color;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }

    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Dash.vue?3c7b51f4